import React from 'react'
import logo from '../../images/logo.png'








function encode(data) {
  return Object.keys(data)
    .map(key => encodeURIComponent(key) + "=" + encodeURIComponent(data[key]))
    .join("&");
}

export default class Footer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  handleChange = (e) => {
    this.setState({[e.target.name]: e.target.value});
  }

  handleSubmit = (e) => {
    e.preventDefault();
    fetch("/", {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: encode({ "form-name": "2018-pfb-annual-report-signup-form", ...this.state })
    })
      .then( () => {
        document.getElementById("pfb-signup-submission").classList.add('hide-form')
        document.getElementById("pfb-signup-result").classList.add('show-form-thanks')
      })
      .catch(
        error => alert("We couldn't add you to the list. Try again and if the problem persists, email placesforbikes@peopleforbikes.org and we'll manually add you to the list.")
      );
  };

  render() {
    return (
      <footer className="pfb-signup">
        <img className="pfb-signup-logo" src={ logo } alt="People for Bikes Logo" />
        <h2 className="pfb-signup-title">Thank You</h2>
        <p className="pfb-signup-text">
          <span>for making 2018 a great year for biking! </span> 
          <span>Join PeopleForBikes to make 2019 even better.</span>
        </p>
        <section className="pfb-signup-form-container">
          <form 
            className="pfb-signup-form" 
            id="pfb-signup-submission" 
            name="2018-pfb-annual-report-signup-form" 
            data-netlify="true" 
            method="post"
            onSubmit={ this.handleSubmit }>
            <p className="pfb-signup-hidden">
              Don’t fill this out: <input name="bot-field" />
            </p>
            <div className="sign-up-group">
              <input type="text" name="first-name" id="pfb-signup-box-fname" className="pfb-signup-box" placeholder="First Name" onChange={ this.handleChange } /> 
              <input type="text" name="last-name" id="pfb-signup-box-lname" className="pfb-signup-box" placeholder="Last Name" onChange={ this.handleChange } />
            </div>
            <div className="sign-up-group sign-up-group-last">
              <input type="email" name="email" id="pfb-signup-box-email" className="pfb-signup-box" placeholder="Email" onChange={ this.handleChange } /> 
              <input type="text" name="zip-code" id="pfb-signup-box-zip" className="pfb-signup-box" placeholder="Zip Code" onChange={ this.handleChange } />
            </div>
            <input type="hidden" name="form-name" value="2018-pfb-annual-report-signup-form" />
            <input type="submit" className="submit-button" value="Sign Up" id="pfb-signup-button" />
          </form>
          <div className="pfb-signup-success-text" id="pfb-signup-result">Thanks for signing up with People for Bikes!</div>
        </section>
        <div className="pfb-footer-bar"></div>
        <div className="pfb-site-link-container">
          Read more about us at <a className="pfb-site-link" href="http://peopleforbikes.org" target="_blank" rel="noopener noreferrer">peopleforbikes.org</a>
        </div>
      </footer>
    )
  }

}